import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Intent } from '@blueprintjs/core';
import moment from 'moment';
import { AlertConfirm, NotificationToaster } from 'components/notifications';
import { WeeklyRestPostponementService } from 'services';

const displayDateFormat = "DD/MM/YYYY";

export function PostponementRemoveConfirm(
    {
        postponement = null,
        onCancel,
        onRemoved
    }
) {
    const [removing, setRemoving] = useState(false);

    function removePostponement() {
        setRemoving(true);

        WeeklyRestPostponementService.deletePostponement(postponement.id).then(() => {
            NotificationToaster.show(Intent.SUCCESS, "Weekly rest postponement removed.");
            onRemoved(postponement);
        }, (errorMessage) => {
            NotificationToaster.show(Intent.DANGER, errorMessage);
            onCancel();
        }).finally(() => {
            setRemoving(false);
        });
    }

    return (
        <AlertConfirm
            title="Remove weekly rest postponement"
            isOpen={postponement != null}
            onConfirm={removePostponement}
            onCancel={onCancel}
            confirmButtonIntent="danger"
            confirmButtonText="Remove"
            saving={removing}
        >
            <p>
                {`Are you sure you want to remove the postponement for ${postponement?.employeeName ?? ""} from ${moment(postponement?.dateFrom).format(displayDateFormat)} to ${moment(postponement?.dateTo).format(displayDateFormat)}?`}
            </p>
        </AlertConfirm>
    );
}

PostponementRemoveConfirm.propTypes = {
    postponement: PropTypes.object,
    onCancel: PropTypes.func.isRequired,
    onRemoved: PropTypes.func.isRequired
};
